import { Box, Flex, Space } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { Button, Link } from '@common/components';
import { PATHS } from 'src/constants';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';

interface Props<T> {
  form?: UseFormReturnType<T, (values: T) => T>;
  title: string;
  description?: JSX.Element;
  link?: JSX.Element;
  children?: JSX.Element;
  submitText?: string;
  onSubmitHandler?: (values: T) => void;
  onErrorHandler?: (errors: any) => void;
  isLoading?: boolean;
  classContainer? : string;
  isSignUp?: boolean
}

const AuthFormHoc = <T,>({
  form,
  title,
  description,
  link,
  children,
  submitText,
  onSubmitHandler,
  onErrorHandler,
  isLoading = false,
  classContainer ,
  isSignUp = false
}: Props<T>): JSX.Element => {

  const [t] = useTranslation('auth');
  return (
    <Box id="main-wrapper"  className={ classContainer  }   >
      {link && <Flex>{link}</Flex>}
      <h1 id={'mainContent'} className={styles.title} tabIndex={-1}>
        {title}
      </h1>
      { description && <p className={styles.description}>{description}</p> }
      {onSubmitHandler && (
        <form className={styles.form} onSubmit={form?.onSubmit(onSubmitHandler, onErrorHandler)}>
          {children}
          {/* <Space h={'md'} /> */}
          <Button buttonStyle={{marginTop:"40px"}} type={'submit'} loading={isLoading} fullWidth>
            {submitText}
          </Button>
          <Space h={'md'} />

          <div style={{textAlign:"center",marginBottom:'20px'}}>
           <p style={{display:'inline-block'}}>  { isSignUp ? 'Already have an account?' : t('doNotHaveAccount') } </p>
           <Link navigateTo={isSignUp ? PATHS.LOGIN : PATHS.SIGN_UP}>{ isSignUp ? 'Log in' : t('signUp')}</Link>
         </div>
         {/* <Space h={'md'} /> */}
        {/* <p style={{textAlign:'center',fontSize:'12px'}}>Contact us if you're running into difficulty at <a href="mailto:support@vially.io">support@vially.io</a></p> */}


        </form>
      )}
    </Box>
  );
};

export default AuthFormHoc;
